import {applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {ContainerList, IContainerList} from '@gongxigames/framework/core';

type DisplayObjectListProps = IContainerList & {
    x?: number;
    y?: number;
    zIndex?: number;
    visible?: boolean;
    sortableChildren?: boolean;
};

export const DisplayObjectList = PixiComponent<DisplayObjectListProps, ContainerList>('DisplayObjectList', {
    create(): ContainerList {
        return new ContainerList();
    },
    applyProps(instance: ContainerList, oldProps: any, newProps: any): void {
        applyDefaultProps(instance, oldProps, newProps);

        instance.updatePositionOfChildren();
    }
});
